<template>
    <section class="section section--team">
        <Heading text="Náš tým" />
        <ul class="section__members">
            <li class="section__member" v-for="member in team" v-bind:key="member.name">
                <Member :portrait="member.portrait" :name="member.name" :position="member.position" :links="member.links" :text="member.text" />
            </li>
        </ul>
    </section>
</template>

<script>
    import Heading from './includes/Heading.vue';
    import Member from './includes/Member.vue';

    export default {
        name: 'Team',
        components: {
            Heading,
            Member
        },
        data() {
            return {
                team: [
                    {
                        portrait: 'misa',
                        name: 'Mgr. et Mgr. Michaela Píšková, MBA, DBA',
                        position: 'manažer IAP, psycholog a trenér',
                        links: {
                            email: 'piskova@iapsychology.cz',
                            phone: '+420702161100',
                            linkedin: 'https://www.linkedin.com/in/michaela-píšková-145234116/'
                        },
                        text: 'Vystudovala jsem psychologii a psychoterapeutická studia na Fakultě sociálních studií Masarykovy univerzity. Při studiu mě zaujala zejména oblast pracovní psychologie. Své znalosti využívám při vedení týmu, vzdělávání a tréninku lidí. Nyní se věnuji zejména řízení a vedení lidí v IAP. Mým cílem je pomáhat lidem realizovat jejich potenciál a podpořit je v tom, aby na sobě pracovali a rozvíjeli se jak po profesní stránce, tak po té lidské. Baví mě začínat nové projekty, zvládat výzvy při jejich realizaci a překonávat sama sebe.'
                    },
                    {
                        portrait: 'petr',
                        name: 'prof. Dr. Petr Pacher',
                        position: 'psycholog a trenér',
                        links: {
                            email: 'ceo@essentialcollege.cz',
                            phone: '+420725427810',
                            linkedin: 'https://www.linkedin.com/in/petr-pacher-10962955/'
                        },
                        text: 'Studoval jsem všeobecné lékařství, které mě následně přivedlo k psychologii a managementu. Výkonnostní psychologii používám mnohem raději než klinické přístupy. Kompiloval jsem řadu psychodiagnostických metod, kterými prošlo více než půl milionu osob. Se svým týmem se věnuji zejména výzkumu v oblasti psychodiagnostiky, konverzační hypnózy a vývoji nových metod pro vzdělávání formou výcviku. Učím na několika vysokých školách jak pro ČR, tak i zahraničí. Jako smysl života vidím vzdělávání lidí pomocí výcviku, kterým si zafixují nové znalosti a dovednosti tak, že když je použijí v praxi, získají mnohem lepší výsledky, než získávali doposud.'
                    },
                    {
                        portrait: 'monika',
                        name: 'Mgr. Monika Křenková',
                        position: 'recruiter',
                        links: {
                            email: 'krenkova@iapsychology.cz',
                            phone: '+420775085877'
                        }
                    },
                    {
                        portrait: 'aneta',
                        name: 'Aneta Ratajská',
                        position: 'asistentka manažera',
                        links: {
                            email: 'office@iapsychology.cz',
                            phone: '+420725442434'
                        }
                    }
                ]
            }
        }
    }
</script>

<style lang="scss" scoped>
    
    .section {

        &__members {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            max-width: 120rem;
            padding-left: 0;
            margin: 6rem auto 0 auto;
            list-style-type: none;
        }

        &__member {
            width: 22%;
        }
    }

    @media (min-width: 1000px) {

        .section__member {
            width: 33.3333%;

            &:first-of-type {
                width: 100%;
            }

            &:not(:first-of-type) {
                margin-top: 8rem;
            }
        }
    }

    @media (max-width: 999px) {
        
        .section {
            padding-bottom: 0;

            &__member {
                width: 50%;
                margin-bottom: 6rem;
            }
        }
    }

    @media (max-width: 499px) {
        
        .section {

            &__member {
                width: 100%;
            }
        }
    }

</style>
